import React, { Component } from 'react';
import TimeConstant from 'constants/Time';
import PureRenderMixin from 'react-addons-pure-render-mixin';

import './Footer.scss';

class Footer extends Component {

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        return (
            <div className="Footer">
                {this.props.isIsraelModeOn ?
                    <span>© 2013–{TimeConstant.Year} Все права защищены</span>
                    :
                    <span>© 2013–{TimeConstant.Year} Онлайн-сервис грузоперевозок «Везёт Всем» - все права защищены</span>
                }
            </div>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./client/components/Footer/Footer.js